var _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleTrack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF75C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFA647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#FFE83F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#9FFF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#70E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#CD93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#CD93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#70E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#9FFF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#FFE83F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#FFA647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF75C3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTrack);
export default __webpack_public_path__ + "static/media/circleTrack.583ee29c0acf42dbdd641b6dfa9e199f.svg";
export { ForwardRef as ReactComponent };